import { apiGet, apiPost } from './client';
import type { Alert, RunAlertsResponse } from '../types/Alert';

export function getAlerts(): Promise<Alert[]> {
  return apiGet<Alert[]>('/api/alerts');
}

// SysAdmin-only — gated server-side on `sysadminTools:Edit`. Triggers the
// per-tenant sp_RunAlerts (DELETE+refill) and returns the fresh count.
export function runAlerts(): Promise<RunAlertsResponse> {
  return apiPost<unknown, RunAlertsResponse>('/api/alerts/run', {});
}
